import { Space } from 'antd'

import { MemberGroupEntity } from '@eastcoal/api/auth/interface'

import { omit } from '@eastcoal/common/utils/object'

import { Select } from '@eastcoal/formily/components/Select'

import { CheckCustomGroupMembersButton } from './CheckCustomGroupMembersButton'
import { CreateOrUpdateCustomGroupButton } from './CreateOrUpdateCustomGroupButton'
import { MemberGroupModalForm } from './CustomGroupForm'
import { BuiltinGroupSelect } from './GroupSelect'
import { MemberGroupSelectProps } from './interface'
import { CustomMemberGroupStoreProvider } from './Store'

const limitMemberOptions = [
  {
    label: '否',
    value: false
  },
  {
    label: '是',
    value: true
  }
]

export const MemberGroupSelect = ({
  disabled,
  value = {},
  onChange
}: MemberGroupSelectProps) => {
  const handleGroupChange = (values?: MemberGroupEntity[]) => {
    onChange?.({
      ...value,
      memberGroups: values?.map(value => ({
        ...omit(value, ['id']),
        groupId: value?.id
      }))
    })
  }

  const { memberGroups, limitMember } = value

  const handleLimitChange = (limit?: boolean) => {
    onChange?.({
      limitMember: limit,
      memberGroups: limit ? value.memberGroups : []
    })
  }

  const formmatterMemberGroups = memberGroups?.map(group => ({
    ...omit(group, ['groupId']),
    id: group.groupId
  }))

  return (
    <Space.Compact block>
      <Select
        allowClear={false}
        options={limitMemberOptions}
        style={{ width: 80 }}
        value={limitMember}
        onChange={handleLimitChange}
      />
      <CustomMemberGroupStoreProvider
        disabled={disabled || !limitMember}
        value={formmatterMemberGroups}
        onChange={handleGroupChange}
      >
        <BuiltinGroupSelect />
        <CheckCustomGroupMembersButton />
        <CreateOrUpdateCustomGroupButton />
        <MemberGroupModalForm />
      </CustomMemberGroupStoreProvider>
    </Space.Compact>
  )
}
